import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { adminPlans, adminPatchPlan } from "@/lib/api";
import { useToast } from "@/hooks/use-toast";
import { Loader2, Save } from "lucide-react";

export default function PlansTab() {
  const qc = useQueryClient();
  const { toast } = useToast();
  const { data, isLoading } = useQuery({ queryKey: ["admin-plans"], queryFn: adminPlans });
  const patchMut = useMutation({
    mutationFn: ({ key, body }) => adminPatchPlan(key, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["admin-plans"] });
      toast({ title: "Plan updated" });
    },
  });
  if (isLoading) return <Loader2 className="size-5 animate-spin text-white/50" />;

  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3" data-testid="admin-plans-grid">
      {(data?.plans || []).map((p) => (
        <PlanCard key={p.key} plan={p} onSave={(body) => patchMut.mutate({ key: p.key, body })} />
      ))}
    </div>
  );
}

function PlanCard({ plan, onSave }) {
  const [price, setPrice] = useState(plan.price_usdt);
  const [days, setDays]   = useState(plan.duration_days);
  const [active, setActive] = useState(plan.active);
  return (
    <div className="rounded-xl border border-white/10 bg-white/5 px-4 py-4 space-y-2" data-testid={`admin-plan-${plan.key}`}>
      <div className="text-xs uppercase tracking-widest text-white/40">{plan.label}</div>
      <label className="block text-xs text-white/60">
        Price (USDT)
        <input type="number" value={price} onChange={(e) => setPrice(Number(e.target.value))}
          className="mt-1 w-full bg-ink-800 border border-white/10 rounded px-2 py-1 text-sm text-white" />
      </label>
      <label className="block text-xs text-white/60">
        Duration (days)
        <input type="number" value={days} onChange={(e) => setDays(Number(e.target.value))}
          className="mt-1 w-full bg-ink-800 border border-white/10 rounded px-2 py-1 text-sm text-white" />
      </label>
      <label className="flex items-center gap-2 text-xs text-white/60">
        <input type="checkbox" checked={active} onChange={(e) => setActive(e.target.checked)} />
        Active
      </label>
      <button
        onClick={() => onSave({ price_usdt: price, duration_days: days, active })}
        className="w-full bg-amber-400/90 text-ink-900 text-xs font-semibold rounded px-3 py-1.5 inline-flex items-center justify-center gap-1"
        data-testid={`admin-plan-save-${plan.key}`}
      >
        <Save className="size-3.5" /> Save
      </button>
    </div>
  );
}
